'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSendVisitorEmailSucceeded = exports.getIsSettingsFetchPending = exports.getIsFetchPending = exports.getHasApiErrorSettings = exports.getHasApiError = exports.SETTINGS_REQUESTS = exports.CHECKED_REQUESTS = exports.getCurrentChatHistoryStatus = exports.getNormalizedSettingsUpdateStatus = exports.getRequestStatus = undefined;

var _fromJS;

var _reselect = require('reselect');

var _immutable = require('immutable');

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _userSelectors = require('conversations-core/selectors/userSelectors');

var _Scopes = require('conversations-core/constants/Scopes');

var Scopes = _interopRequireWildcard(_Scopes);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getRequestStatus = exports.getRequestStatus = function getRequestStatus(state) {
  return state.requestStatus;
};

var getCurrentChannel = function getCurrentChannel(state) {
  return state.currentChannel;
};

var FAILED = _RequestStatusTypes2.default.FAILED,
    SUCCEEDED = _RequestStatusTypes2.default.SUCCEEDED,
    PENDING = _RequestStatusTypes2.default.PENDING,
    UNINITIALIZED = _RequestStatusTypes2.default.UNINITIALIZED;
var getNormalizedSettingsUpdateStatus = exports.getNormalizedSettingsUpdateStatus = (0, _reselect.createSelector)([getRequestStatus], function (requestStatus) {
  var userSettingsUpdateStatus = requestStatus.userSettingsUpdateStatus,
      portalSettingsUpdateStatus = requestStatus.portalSettingsUpdateStatus;


  switch (true) {
    case userSettingsUpdateStatus === PENDING || portalSettingsUpdateStatus === PENDING:
      return PENDING;
    case userSettingsUpdateStatus === FAILED || portalSettingsUpdateStatus === FAILED:
      return FAILED;
    case userSettingsUpdateStatus === SUCCEEDED && portalSettingsUpdateStatus === SUCCEEDED:
      return SUCCEEDED;
    default:
      return UNINITIALIZED;
  }
});

var getCurrentChatHistoryStatus = exports.getCurrentChatHistoryStatus = (0, _reselect.createSelector)([getRequestStatus, getCurrentChannel], function (requestStatus, currentChannel) {
  var chatHistoryFetchStatus = requestStatus.chatHistoryFetchStatus;

  var channelStatus = chatHistoryFetchStatus.get(currentChannel) || UNINITIALIZED;

  return channelStatus;
});

var CHECKED_REQUESTS = exports.CHECKED_REQUESTS = new _immutable.List(['messagesFetchStatus', 'usersFetchStatus', 'conversationsFetchStatus', 'smartListsFetchStatus', 'serverTimeOffsetStatus']);

var SETTINGS_REQUESTS = exports.SETTINGS_REQUESTS = new _immutable.List(['messagesFetchStatus']);

var getHasApiError = exports.getHasApiError = (0, _reselect.createSelector)([getRequestStatus], function (requestStatuses) {
  return (0, _pick2.default)(CHECKED_REQUESTS, (0, _immutable.fromJS)(requestStatuses)).includes(_RequestStatusTypes2.default.FAILED);
});

var getHasApiErrorSettings = exports.getHasApiErrorSettings = (0, _reselect.createSelector)([getRequestStatus], function (requestStatuses) {
  return (0, _pick2.default)(SETTINGS_REQUESTS, (0, _immutable.fromJS)(requestStatuses)).includes(_RequestStatusTypes2.default.FAILED);
});

var FETCH_PENDING_STATUS_TYPES = [_RequestStatusTypes2.default.UNINITIALIZED, _RequestStatusTypes2.default.PENDING];

var scopeRequestStatusMap = (0, _immutable.fromJS)((_fromJS = {}, _defineProperty(_fromJS, Scopes.MESSAGES_READ, ['messagesFetchStatus', 'portalSettingsFetchStatus', 'userSettingsFetchStatus']), _defineProperty(_fromJS, Scopes.MESSAGES_CHAT, ['conversationsFetchStatus', 'serverTimeOffsetStatus']), _fromJS));

var getIsFetchPending = exports.getIsFetchPending = (0, _reselect.createSelector)([getRequestStatus, _userSelectors.getScopes], function (requestStatuses, scopes) {
  return (0, _pick2.default)(scopeRequestStatusMap.reduce(function (necessaryStatuses, statuses, scopeKey) {
    if (scopes.includes(scopeKey)) {
      return necessaryStatuses.concat(statuses);
    }
    return necessaryStatuses;
  }, new _immutable.List()), requestStatuses).some(function (requestStatus) {
    return FETCH_PENDING_STATUS_TYPES.includes(requestStatus);
  });
});

var getIsSettingsFetchPending = exports.getIsSettingsFetchPending = (0, _reselect.createSelector)([getRequestStatus], function (requestStatuses) {
  return (0, _pick2.default)(SETTINGS_REQUESTS, requestStatuses).some(function (requestStatus) {
    return FETCH_PENDING_STATUS_TYPES.includes(requestStatus);
  });
});

var getSendVisitorEmailSucceeded = exports.getSendVisitorEmailSucceeded = (0, _reselect.createSelector)([getRequestStatus], function (requestStatuses) {
  return requestStatuses.sendVisitorEmailAddressStatus === SUCCEEDED;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/requestStatusSelectors.js
// module id = 157
// module chunks = 0 1